<template>
  <div class="pk-pizza-set-page pk-account-panel">
    <section class="pk-pizza-set-target-hero">
      <span>披萨套装</span>
      <h1>打造你的梦想套装</h1>
      <p>为 CS2 选择并收集属于你的理想饰品组合。</p>
      <div class="pk-pizza-set-team-toggle">
        <button :class="{ active: team === 'ct' }" @click="team = 'ct'">反恐精英</button>
        <button :class="{ active: team === 't' }" @click="team = 't'">恐怖分子</button>
      </div>
    </section>

    <section class="pk-pizza-set-builder">
      <header class="pk-pizza-set-builder-head">
        <div>
          <span>选择阵营</span>
          <strong>{{ teamLabel }}</strong>
        </div>
        <div class="pk-pizza-set-actions">
          <button :class="{ active: locked }" @click="toggleLock">{{ locked ? '已锁定' : '锁定' }}</button>
          <button disabled>收集 10 000 奶酪币</button>
          <button @click="randomizeSet">随机披萨套装</button>
          <button @click="clearSet">清空</button>
        </div>
      </header>

      <div class="pk-pizza-set-why">
        <strong>为什么要在 PizzaKing 创建套装？</strong>
        <span>集齐九件套装可参与对应奖励。</span>
      </div>

      <section class="pk-pizza-set-slots">
        <div class="pk-pizza-set-section-title">
          <strong>在哪里获得这些饰品？</strong>
          <span>选择饰品可查看可获得途径</span>
        </div>
        <div class="pk-pizza-set-slot-grid">
          <article v-for="(item, index) in selectedItems" :key="item.id" class="pk-pizza-set-slot">
            <span class="pk-pizza-set-slot-index">{{ index + 1 }}</span>
            <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.shortName" @error="useSkinFallback" />
            <span v-else class="pk-pizza-set-empty">+</span>
            <strong>{{ item.shortName }}</strong>
            <em>{{ Number(item.price || 0).toFixed(2) }} <i></i></em>
            <button type="button" @click="showSetInfo">+</button>
          </article>
        </div>
      </section>
    </section>

    <section class="pk-pizza-set-case-maker">
      <div class="pk-pizza-set-case-head">
        <div>
          <span>箱子创建器</span>
          <h2>期望箱子价格</h2>
        </div>
        <div class="pk-pizza-set-price-preset">
          <button v-for="price in [3, 6, 15, 25, 50, 100]" :key="price" :class="{ active: selectedCasePrice === price }" @click="selectedCasePrice = price">{{ price }}</button>
        </div>
      </div>
      <div class="pk-pizza-set-case-tools">
        <button class="pk-pizza-set-generate" disabled>生成</button>
        <button disabled>手动概率模式</button>
        <span>选择箱子组合。</span>
      </div>
      <div class="pk-pizza-set-case-grid">
        <article v-for="item in selectedItems" :key="`case-${item.id}`">
          <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.shortName" @error="useSkinFallback" />
          <strong>{{ item.shortName }}</strong>
          <span>0.000%</span>
        </article>
        <article class="pk-pizza-set-random-item"><b>?</b><strong>随机饰品</strong><span>0.000%</span></article>
        <article class="pk-pizza-set-random-item"><b>?</b><strong>随机饰品</strong><span>0.000%</span></article>
      </div>
    </section>

    <section class="pk-pizza-set-terms">
      <h2>参与规则</h2>
      <strong>披萨套装</strong>
      <p>选择阵营并查看套装组合。</p>
    </section>

    <section class="pk-set-hero">
      <div>
        <span>披萨套装</span>
        <h1>&#25259;&#33832;&#22871;&#35013;</h1>
        <p>&#36873;&#25321;&#22871;&#35013;&#24182;&#26597;&#30475;&#21487;&#33719;&#24471;&#30340;&#31665;&#23376;&#21644;&#39280;&#21697;&#32452;&#21512;&#12290;</p>
      </div>
      <div class="pk-set-switches">
        <div>
          <button :class="{ active: tier === 'normal' }" @click="tier = 'normal'">普通</button>
          <button :class="{ active: tier === 'luxury' }" @click="tier = 'luxury'">豪华</button>
        </div>
        <div>
          <button :class="{ active: team === 't' }" @click="team = 't'">T 阵营</button>
          <button :class="{ active: team === 'ct' }" @click="team = 'ct'">CT 阵营</button>
        </div>
        <button class="pk-set-random" @click="randomizeSet">随机搭配</button>
      </div>
    </section>

    <section v-if="activeSet" class="pk-set-layout">
      <main class="pk-set-list">
        <article
          v-for="set in sets"
          :key="set.name"
          :class="['pk-set-card', { active: set.name === activeSet.name }]"
          @click="active = set.name"
        >
          <div class="pk-set-card-glow"></div>
          <img :src="set.img" :alt="set.name" />
          <span>{{ set.tag }}</span>
          <strong>{{ set.name }}</strong>
          <p>{{ set.desc }}</p>
          <b>{{ set.price }}</b>
        </article>
      </main>

      <aside class="pk-set-detail">
        <div class="pk-set-detail-head">
          <span>&#24403;&#21069;&#22871;&#35013;</span>
          <strong>{{ activeSet.name }}</strong>
        </div>
        <div class="pk-set-preview">
          <img :src="activeSet.img" :alt="activeSet.name" />
        </div>
        <div class="pk-set-summary">
          <p><span>&#22871;&#35013;&#20215;&#26684;</span><b>{{ activeSet.price }}</b></p>
          <p><span>&#21253;&#21547;&#29289;&#21697;</span><b>{{ activeSet.items.length }}</b></p>
          <p><span>&#29366;&#24577;</span><b>{{ locked ? '已锁定' : '未锁定' }}</b></p>
        </div>
        <div class="pk-set-actions">
          <button class="primary" @click="toggleLock">{{ locked ? '取消锁定' : '锁定套装' }}</button>
          <button @click="showSetInfo">&#26597;&#30475;&#26041;&#26696;</button>
        </div>
      </aside>
    </section>

    <section v-else class="pk-set-empty-layout">
      <strong>暂无可参与的 Pizza Set 方案</strong>
      <span>暂无套装数据</span>
    </section>

    <section v-if="activeSet" class="pk-set-items">
      <div class="pk-set-section-head">
        <strong>&#22871;&#35013;&#20869;&#23481;</strong>
        <span>{{ activeSet.name }}</span>
      </div>
      <div class="pk-set-item-grid">
        <article v-for="item in activeSet.items" :key="item.name" class="pk-set-item">
          <img :src="item.img" :alt="item.name" />
          <strong>{{ item.name }}</strong>
          <span>{{ item.price }}</span>
        </article>
      </div>
    </section>

    <section v-if="activeSet" class="pk-set-rules">
      <article>
        <b>1</b>
        <strong>&#36873;&#25321;&#22871;&#35013;</strong>
        <span>&#19981;&#21516;&#22871;&#35013;&#23545;&#24212;&#19981;&#21516;&#31665;&#23376;&#21644;&#39280;&#21697;&#32452;&#21512;&#12290;</span>
      </article>
      <article>
        <b>2</b>
        <strong>&#30830;&#35748;&#20215;&#26684;</strong>
        <span>&#24320;&#21551;&#21069;&#21487;&#20197;&#26597;&#30475;&#20840;&#37096;&#21487;&#33719;&#24471;&#29289;&#21697;&#12290;</span>
      </article>
      <article>
        <b>3</b>
        <strong>&#33719;&#24471;&#22870;&#21169;</strong>
        <span>&#33719;&#24471;&#30340;&#39280;&#21697;&#23558;&#36827;&#20837;&#32972;&#21253;&#35760;&#24405;&#12290;</span>
      </article>
    </section>

    <div v-if="panel" class="pk-set-modal" @click.self="closePanel">
      <section class="pk-set-modal-card">
        <button class="pk-set-modal-close" @click="closePanel">×</button>
        <span>方案预览</span>
        <h2>{{ activeSet ? `${tier === 'normal' ? '普通' : '豪华'} ${team === 't' ? 'T 阵营' : 'CT 阵营'}` : '套装方案待配置' }}</h2>
        <p v-if="activeSet">已选择 {{ activeSet.name }}</p>
        <p v-else>请选择套装方案</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "PizzaSet",
  data() {
    return {
      active: "",
      tier: "normal",
      team: "t",
      locked: false,
      panel: "",
      skins: [],
      skinFallbackImage: require("../assets/hotpizza/hp-m4-blue.png"),
      skinImageCache: {
        809: require("../assets/skin-cache/pizzaset-809.png"),
        658: require("../assets/skin-cache/pizzaset-658.png"),
        758: require("../assets/skin-cache/pizzaset-758.png"),
        816: require("../assets/skin-cache/pizzaset-816.png"),
        773: require("../assets/skin-cache/pizzaset-773.png"),
        759: require("../assets/skin-cache/pizzaset-759.png"),
        765: require("../assets/skin-cache/pizzaset-765.png"),
        777: require("../assets/skin-cache/pizzaset-777.png"),
        822: require("../assets/skin-cache/pizzaset-822.png"),
      },
      selectedCasePrice: 3,
      sets: [],
    };
  },
  computed: {
    activeSet() {
      return this.sets.find((item) => item.name === this.active) || null;
    },
    teamLabel() {
      return this.team === "ct" ? "反恐精英" : "恐怖分子";
    },
    selectedItems() {
      if (this.skins.length) return this.skins;
      return Array.from({ length: 9 }, (_, index) => ({
        id: `set-waiting-${index}`,
        shortName: "选择饰品查看获得途径",
        price: 0,
        imageUrl: "",
      }));
    },
  },
  mounted() {
    this.$axios.get("/index/Lucky/skinList?page=1&limit=9").then((res) => {
      if (res.data.status === 1) {
        this.skins = res.data.data.list.slice(0, 9).map((item) => ({
          ...item,
          imageUrl: this.skinImageCache[item.id] || item.imageUrl,
        }));
      }
    });
  },
  methods: {
    useSkinFallback(event) {
      event.target.onerror = null;
      event.target.src = this.skinFallbackImage;
    },
    toggleLock() {
      this.locked = !this.locked;
    },
    randomizeSet() {
      this.skins = [...this.skins].sort(() => Math.random() - 0.5);
      this.locked = false;
    },
    clearSet() {
      this.skins = [];
      this.locked = false;
    },
    showSetInfo() {
      this.panel = "info";
    },
    closePanel() {
      this.panel = "";
    },
  },
};
</script>

<style lang="less" scoped>
.pk-pizza-set-page {
  min-height: calc(100vh - 199px);
  padding: 18px 24px 96px;
  color: #f4f6ff;
  background:
    radial-gradient(ellipse at 50% 220px, rgba(255, 208, 102, 0.08), transparent 460px),
    #191b26;
}

.pk-set-hero {
  min-height: 104px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background:
    radial-gradient(ellipse at 18% 50%, rgba(255, 208, 102, 0.13), transparent 340px),
    #20222f;
}

.pk-set-hero span,
.pk-set-detail-head span,
.pk-set-section-head span {
  color: #ffbd42;
  font-size: 12px;
  font-weight: 900;
}

.pk-set-hero h1 {
  margin: 4px 0 6px;
  color: #fff7df;
  font-size: 26px;
}

.pk-set-hero p {
  margin: 0;
  color: #8f98ab;
  font-size: 13px;
}

.pk-set-hero button,
.pk-set-actions button {
  height: 42px;
  padding: 0 22px;
  color: #ecd8b8;
  border: 1px solid rgba(236, 216, 184, 0.42);
  border-radius: 7px;
  background: transparent;
  font-weight: 900;
}

.pk-set-switches {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.pk-set-switches > div {
  display: flex;
}

.pk-set-switches button {
  min-width: 54px;
  height: 34px;
  padding: 0 10px;
  color: #bfc7d5;
  border: 1px solid #3a3e50;
  background: #252837;
  font-size: 12px;
}

.pk-set-switches button + button {
  margin-left: -1px;
}

.pk-set-switches button.active {
  position: relative;
  z-index: 1;
  color: #fff4db;
  border-color: rgba(255, 189, 66, 0.72);
  background: #343746;
}

.pk-set-switches .pk-set-random {
  color: #fff7df;
  border-color: rgba(255, 189, 66, 0.64);
  background: linear-gradient(180deg, #ff971f, #f26b00);
}

.pk-set-layout {
  margin-top: 8px;
  display: grid;
  grid-template-columns: minmax(620px, 1fr) 340px;
  gap: 8px;
}

.pk-set-empty-layout {
  min-height: 184px;
  margin-top: 8px;
  padding: 28px;
  display: grid;
  place-content: center;
  gap: 9px;
  text-align: center;
  border: 1px dashed #42485e;
  border-radius: 8px;
  background: #20222f;
}

.pk-set-empty-layout strong { color: #eceffc; font-size: 16px; }
.pk-set-empty-layout span { max-width: 620px; color: #929ab0; font-size: 13px; line-height: 1.7; }

.pk-set-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.pk-set-card,
.pk-set-detail,
.pk-set-items,
.pk-set-rules article {
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background: #20222f;
}

.pk-set-card {
  position: relative;
  min-height: 346px;
  padding: 22px;
  overflow: hidden;
  cursor: pointer;
}

.pk-set-card.active {
  border-color: rgba(255, 189, 66, 0.58);
}

.pk-set-card-glow {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 50% 38%, rgba(255, 208, 102, 0.16), transparent 43%),
    radial-gradient(ellipse at 50% 86%, rgba(253, 107, 1, 0.08), transparent 62%);
  pointer-events: none;
}

.pk-set-card img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 168px;
  object-fit: contain;
  filter: drop-shadow(0 24px 26px rgba(0, 0, 0, 0.44));
}

.pk-set-card span {
  position: relative;
  z-index: 1;
  display: inline-flex;
  margin-top: 18px;
  padding: 4px 9px;
  color: #11131d;
  border-radius: 5px;
  background: #ffbd42;
  font-size: 11px;
  font-weight: 900;
}

.pk-set-card strong {
  position: relative;
  z-index: 1;
  display: block;
  margin-top: 12px;
  color: #fff7df;
  font-size: 18px;
}

.pk-set-card p {
  position: relative;
  z-index: 1;
  min-height: 38px;
  margin: 8px 0 12px;
  color: #8f98ab;
  font-size: 13px;
  line-height: 19px;
}

.pk-set-card b {
  position: relative;
  z-index: 1;
  color: #ffbd42;
  font-size: 20px;
}

.pk-set-detail {
  overflow: hidden;
}

.pk-set-detail-head,
.pk-set-section-head {
  height: 58px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #2b2d3c;
}

.pk-set-detail-head strong,
.pk-set-section-head strong {
  color: #f4ead8;
  font-size: 16px;
}

.pk-set-preview {
  min-height: 238px;
  margin: 12px;
  display: grid;
  place-items: center;
  border: 1px solid #303443;
  border-radius: 7px;
  background:
    radial-gradient(circle at 50% 48%, rgba(255, 208, 102, 0.18), transparent 54%),
    #252837;
}

.pk-set-preview img {
  max-width: 260px;
  max-height: 182px;
  object-fit: contain;
}

.pk-set-summary {
  padding: 0 12px;
}

.pk-set-summary p {
  height: 42px;
  margin: 0 0 8px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #8f98ab;
  border-radius: 6px;
  background: #252837;
}

.pk-set-summary b {
  color: #ffbd42;
}

.pk-set-actions {
  padding: 4px 12px 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.pk-set-actions .primary {
  color: #fff7df;
  border-color: rgba(255, 214, 128, 0.35);
  background: linear-gradient(180deg, #ff971f, #f26b00);
}

.pk-set-items {
  margin-top: 8px;
  overflow: hidden;
}

.pk-set-item-grid {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 8px;
}

.pk-set-item {
  min-height: 178px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #303443;
  border-radius: 7px;
  background:
    radial-gradient(circle at 50% 38%, rgba(255, 208, 102, 0.1), transparent 48%),
    #252837;
}

.pk-set-item img {
  max-width: 142px;
  max-height: 90px;
  object-fit: contain;
  filter: drop-shadow(0 14px 16px rgba(0, 0, 0, 0.38));
}

.pk-set-item strong {
  margin-top: 12px;
  color: #f5f7ff;
  font-size: 12px;
  text-align: center;
}

.pk-set-item span {
  margin-top: 7px;
  color: #ffbd42;
  font-size: 14px;
  font-weight: 900;
}

.pk-set-rules {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.pk-set-rules article {
  min-height: 92px;
  padding: 18px;
  display: grid;
  grid-template-columns: 36px 1fr;
  column-gap: 12px;
}

.pk-set-rules b {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  color: #11131d;
  border-radius: 50%;
  background: #ffbd42;
}

.pk-set-rules strong {
  color: #fff7df;
}

.pk-set-rules span {
  grid-column: 2;
  color: #8f98ab;
  font-size: 13px;
}

.pk-set-modal {
  position: fixed;
  z-index: 80;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(11, 12, 18, 0.76);
}

.pk-set-modal-card {
  width: 470px;
  max-width: 100%;
  position: relative;
  padding: 30px;
  color: #f7f1e4;
  background: radial-gradient(circle at 50% 0, rgba(255, 189, 66, 0.14), transparent 48%), #242735;
  border: 1px solid rgba(238, 216, 181, 0.28);
  border-radius: 9px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.46);
}

.pk-set-modal-card > span { color: #ffbd42; font-size: 12px; font-weight: 1000; letter-spacing: 0.1em; }
.pk-set-modal-card h2 { margin: 8px 0 14px; font-size: 24px; }
.pk-set-modal-card p { margin: 0; color: #b5becd; font-size: 14px; line-height: 1.8; }

.pk-set-modal-close {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #f4ead8;
  background: transparent;
  border: 0;
  font-size: 28px;
  line-height: 1;
}

@media (max-width: 1280px) {
  .pk-set-layout,
  .pk-set-list,
  .pk-set-rules {
    grid-template-columns: 1fr;
  }
}
</style>

<style lang="less">
/* 2026-07-21 target-pass: Pizza Set follows the target side, nine-slot, and case-maker structure. */
.pk-pizza-set-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 75px 96px !important;
  color: #e8ebf6;
  background:
    radial-gradient(ellipse at 50% 180px, rgba(91, 71, 224, 0.11), transparent 440px),
    #1f2130 !important;
}

.pk-pizza-set-page .pk-set-hero,
.pk-pizza-set-page .pk-set-layout,
.pk-pizza-set-page .pk-set-items,
.pk-pizza-set-page .pk-set-rules { display: none; }

.pk-pizza-set-target-hero {
  min-height: 168px;
  position: relative;
  padding: 32px 36px;
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background:
    radial-gradient(circle at 19% 48%, rgba(124, 101, 255, 0.28), transparent 32%),
    linear-gradient(90deg, #24263a, #1f2130 66%);
}

.pk-pizza-set-target-hero > span,
.pk-pizza-set-case-head > div > span {
  color: #8e7bff;
  font-size: 12px;
  font-weight: 1000;
  letter-spacing: 0.14em;
}

.pk-pizza-set-target-hero h1 {
  margin: 7px 0 8px;
  color: #f2f3ff;
  font-size: 34px;
  line-height: 1;
}

.pk-pizza-set-target-hero p {
  max-width: 510px;
  margin: 0;
  color: #a7aec1;
  font-size: 14px;
}

.pk-pizza-set-team-toggle {
  position: absolute;
  right: 36px;
  bottom: 34px;
  display: flex;
  overflow: hidden;
  border: 1px solid #555b79;
  border-radius: 7px;
}

.pk-pizza-set-team-toggle button,
.pk-pizza-set-actions button,
.pk-pizza-set-price-preset button,
.pk-pizza-set-case-tools button {
  font: inherit;
  cursor: pointer;
}

.pk-pizza-set-team-toggle button {
  min-width: 152px;
  height: 44px;
  color: #aeb6cb;
  border: 0;
  background: #292c3e;
  font-size: 13px;
  font-weight: 1000;
}

.pk-pizza-set-team-toggle button.active {
  color: #fff;
  background: linear-gradient(180deg, #8066ff, #5d49d5);
}

.pk-pizza-set-builder,
.pk-pizza-set-case-maker,
.pk-pizza-set-terms {
  margin-top: 14px;
  border: 1px solid #34384e;
  background: #242637;
}

.pk-pizza-set-builder-head {
  min-height: 82px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid #34384e;
}

.pk-pizza-set-builder-head > div:first-child span,
.pk-pizza-set-section-title span {
  display: block;
  color: #919ab1;
  font-size: 12px;
}

.pk-pizza-set-builder-head > div:first-child strong {
  display: block;
  margin-top: 5px;
  color: #f0f2fb;
  font-size: 21px;
}

.pk-pizza-set-actions { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 8px; }

.pk-pizza-set-actions button {
  height: 36px;
  padding: 0 13px;
  color: #d7dbec;
  border: 1px solid #555d7b;
  border-radius: 5px;
  background: #2c2f43;
  font-size: 12px;
  font-weight: 900;
}

.pk-pizza-set-actions button.active { color: #90ffbd; border-color: #46be7c; }
.pk-pizza-set-actions button:disabled { color: #737b91; cursor: not-allowed; }

.pk-pizza-set-why {
  margin: 18px 28px 0;
  padding: 17px 20px;
  display: grid;
  gap: 6px;
  border-left: 3px solid #8066ff;
  background: rgba(128, 102, 255, 0.08);
}

.pk-pizza-set-why strong { color: #f0f2fb; font-size: 14px; }
.pk-pizza-set-why span { color: #9fa8bf; font-size: 13px; line-height: 1.55; }

.pk-pizza-set-slots { padding: 24px 28px 30px; }
.pk-pizza-set-section-title { margin-bottom: 14px; }
.pk-pizza-set-section-title strong { display: block; color: #f0f2fb; font-size: 19px; }
.pk-pizza-set-section-title span { margin-top: 5px; }

.pk-pizza-set-slot-grid {
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  border: 1px solid #3a3e54;
}

.pk-pizza-set-slot {
  min-width: 0;
  min-height: 204px;
  position: relative;
  padding: 16px 9px 12px;
  display: grid;
  grid-template-rows: 104px auto auto;
  justify-items: center;
  border-right: 1px solid #3a3e54;
  background: linear-gradient(180deg, #292c40, #232536);
}

.pk-pizza-set-slot:last-child { border-right: 0; }
.pk-pizza-set-slot-index { position: absolute; top: 9px; left: 10px; color: #757f99; font-size: 11px; font-weight: 1000; }
.pk-pizza-set-slot img { width: 100%; height: 98px; object-fit: contain; filter: drop-shadow(0 10px 12px rgba(0, 0, 0, 0.38)); }
.pk-pizza-set-empty { width: 52px; height: 52px; margin-top: 26px; display: grid; place-items: center; color: #7c85a0; border: 1px dashed #555e7b; border-radius: 50%; font-size: 27px; }
.pk-pizza-set-slot > strong { width: 100%; overflow: hidden; color: #e7eaf6; font-size: 11px; text-align: center; text-overflow: ellipsis; white-space: nowrap; }
.pk-pizza-set-slot em { display: flex; align-items: center; gap: 3px; margin-top: 5px; color: #f6ca59; font-size: 11px; font-style: normal; font-weight: 1000; }
.pk-pizza-set-slot em i { width: 11px; height: 11px; background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat; }
.pk-pizza-set-slot > button { width: 24px; height: 24px; position: absolute; right: 7px; bottom: 7px; color: #d9deed; border: 1px solid #5f6680; border-radius: 50%; background: #303449; font-size: 16px; line-height: 1; cursor: pointer; }

.pk-pizza-set-case-maker { padding: 27px 28px 30px; }
.pk-pizza-set-case-head { display: flex; align-items: end; justify-content: space-between; gap: 24px; }
.pk-pizza-set-case-head h2 { margin: 5px 0 0; color: #f0f2fb; font-size: 22px; }
.pk-pizza-set-price-preset { display: flex; gap: 6px; }
.pk-pizza-set-price-preset button { width: 43px; height: 33px; color: #aeb7cf; border: 1px solid #555d7b; border-radius: 4px; background: #2d3043; font-size: 12px; font-weight: 1000; }
.pk-pizza-set-price-preset button.active { color: #fff; border-color: #8e7bff; background: #5e4bd5; }

.pk-pizza-set-case-tools { margin: 22px 0; display: flex; align-items: center; gap: 10px; }
.pk-pizza-set-case-tools button { height: 40px; padding: 0 22px; color: #7d8499; border: 1px solid #4c526a; border-radius: 4px; background: #2b2e40; font-weight: 1000; cursor: not-allowed; }
.pk-pizza-set-case-tools .pk-pizza-set-generate { color: #b7afdc; border-color: #6557a8; background: #373152; }
.pk-pizza-set-case-tools span { color: #8790a8; font-size: 12px; }

.pk-pizza-set-case-grid { display: grid; grid-template-columns: repeat(11, minmax(0, 1fr)); border: 1px solid #3a3e54; }
.pk-pizza-set-case-grid article { min-width: 0; min-height: 150px; padding: 10px 6px; display: grid; grid-template-rows: 76px auto auto; justify-items: center; border-right: 1px solid #3a3e54; background: #272a3b; }
.pk-pizza-set-case-grid article:last-child { border-right: 0; }
.pk-pizza-set-case-grid img { width: 100%; height: 72px; object-fit: contain; }
.pk-pizza-set-case-grid strong { width: 100%; overflow: hidden; color: #dfe4f4; font-size: 10px; text-align: center; text-overflow: ellipsis; white-space: nowrap; }
.pk-pizza-set-case-grid span { margin-top: 5px; color: #aab2c8; font-size: 11px; }
.pk-pizza-set-random-item b { width: 46px; height: 46px; margin-top: 12px; display: grid; place-items: center; color: #8b93aa; border: 1px dashed #5d6580; border-radius: 50%; font-size: 25px; }

.pk-pizza-set-terms { padding: 28px 32px; }
.pk-pizza-set-terms h2 { margin: 0 0 16px; color: #f0f2fb; font-size: 22px; }
.pk-pizza-set-terms strong { color: #8e7bff; font-size: 12px; letter-spacing: 0.13em; }
.pk-pizza-set-terms p { max-width: 1000px; margin: 12px 0 0; color: #9ea7be; font-size: 13px; line-height: 1.75; }

@media (max-width: 1320px) {
  .pk-pizza-set-page.pk-account-panel { padding-left: 24px !important; padding-right: 24px !important; }
  .pk-pizza-set-slot-grid { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .pk-pizza-set-slot:nth-child(5) { border-right: 0; }
  .pk-pizza-set-case-grid { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .pk-pizza-set-case-grid article:nth-child(6) { border-right: 0; }
}

@media (max-width: 760px) {
  .pk-pizza-set-target-hero { padding: 26px 20px 94px; }
  .pk-pizza-set-team-toggle { right: 20px; left: 20px; bottom: 24px; }
  .pk-pizza-set-team-toggle button { flex: 1; min-width: 0; }
  .pk-pizza-set-builder-head, .pk-pizza-set-case-head { padding: 20px; align-items: flex-start; flex-direction: column; }
  .pk-pizza-set-actions, .pk-pizza-set-price-preset { justify-content: flex-start; }
  .pk-pizza-set-slots, .pk-pizza-set-case-maker, .pk-pizza-set-terms { padding-left: 16px; padding-right: 16px; }
  .pk-pizza-set-slot-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .pk-pizza-set-slot:nth-child(3n) { border-right: 0; }
  .pk-pizza-set-case-tools { align-items: flex-start; flex-wrap: wrap; }
  .pk-pizza-set-case-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .pk-pizza-set-case-grid article:nth-child(3n) { border-right: 0; }
}
</style>
